export const StarIcon = ({
  height = 24,
  width = 24,
  color = "#3E50F7",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M13.7276 3.44418L15.4874 6.99288C15.7274 7.48687 16.3673 7.9607 16.9073 8.05143L20.0969 8.58575C22.1367 8.92853 22.6167 10.4206 21.1468 11.8925L18.6671 14.3927C18.2471 14.8161 18.0172 15.6327 18.1471 16.2175L18.8571 19.3125C19.417 21.7623 18.1271 22.71 15.9774 21.4296L12.9877 19.6452C12.4478 19.3226 11.5579 19.3226 11.0079 19.6452L8.01827 21.4296C5.8785 22.71 4.57865 21.7522 5.13859 19.3125L5.84851 16.2175C5.97849 15.6327 5.74852 14.8161 5.32856 14.3927L2.84884 11.8925C1.389 10.4206 1.85895 8.92853 3.89872 8.58575L7.08837 8.05143C7.61831 7.9607 8.25824 7.48687 8.49821 6.99288L10.258 3.44418C11.2179 1.51861 12.7777 1.51861 13.7276 3.44418Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const TargetIcon = ({
  height = 24,
  width = 24,
  color = "#0B703B",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.0576 20.8555 10.1508 20.5881 9.29965C20.4227 8.77274 20.7156 8.21144 21.2425 8.04595C21.7695 7.88046 22.3308 8.17344 22.4962 8.70035C22.8238 9.74323 23 10.852 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C13.2012 1 14.3594 1.19291 15.444 1.5502C15.9686 1.723 16.2537 2.28831 16.081 2.81287C15.9082 3.33743 15.3428 3.62259 14.8183 3.4498C13.933 3.15818 12.986 3 12 3Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 1C19.5523 1 20 1.44772 20 2V4H22C22.5523 4 23 4.44772 23 5C23 5.55228 22.5523 6 22 6H19.4142L12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929L18 4.58579V2C18 1.44772 18.4477 1 19 1Z"
        fill={color}
      />
    </svg>
  );
};
export const TrophyIcon = ({
  height = 24,
  width = 24,
  color = "#FFA488",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M12 17C9.79086 17 8 19.2386 8 22H16C16 19.2386 14.2091 17 12 17Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5 5H22L21.7616 6.66896C21.4984 8.51101 21.3669 9.43204 21.001 10.2267C20.6067 11.0831 20.0161 11.8345 19.2772 12.4201C18.5915 12.9634 17.7277 13.3089 16 14"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.5 5H2L2.23842 6.66896C2.50157 8.51101 2.63315 9.43204 2.99902 10.2267C3.39331 11.0831 3.98387 11.8345 4.72282 12.4201C5.4085 12.9634 6.27233 13.3089 8 14"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9998 17C8.55573 17 5.73726 10.8185 5.51407 3.00094C5.49831 2.44888 5.94755 2 6.49983 2H17.4998C18.0521 2 18.5013 2.44888 18.4856 3.00093C18.2624 10.8185 15.4439 17 11.9998 17Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const AchievedIcon = ({
  height = 24,
  width = 24,
  color = "#3C568D",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M8.62224 9.51493L7.8116 12.7575C7.65382 13.3886 8.13118 14 8.78175 14H15.2202C15.8708 14 16.3482 13.3886 16.1904 12.7575L15.3797 9.51493C15.1571 8.62459 14.3572 8 13.4394 8H10.5626C9.64479 8 8.84482 8.62459 8.62224 9.51493Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.12224 17.5149L2.3116 20.7575C2.15382 21.3886 2.63118 22 3.28175 22H9.72019C10.3708 22 10.8482 21.3886 10.6904 20.7575L9.8797 17.5149C9.65712 16.6246 8.85715 16 7.93942 16H5.06252C4.14479 16 3.34482 16.6246 3.12224 17.5149Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1203 17.5149L13.3096 20.7575C13.1518 21.3886 13.6292 22 14.2798 22H20.7182C21.3688 22 21.8462 21.3886 21.6884 20.7575L20.8777 17.5149C20.6551 16.6246 19.8552 16 18.9374 16H16.0606C15.1428 16 14.3429 16.6246 14.1203 17.5149Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 2V4M7.5 3.5L9 5M16.5 3.5L15 5"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};
export const PercentArrowDownIcon = ({
  height = 20,
  width = 20,
  color = "#ff0055",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.02032 14.9809C5.2994 15.26 5.68207 15.4104 6.00023 15.5033C6.34307 15.6033 6.73924 15.6716 7.14924 15.7194C7.9714 15.8154 8.94474 15.84 9.8599 15.8328C10.7802 15.8256 11.6649 15.786 12.318 15.7485C12.6451 15.7296 13.4039 15.6745 13.4039 15.6745C13.8626 15.6358 14.203 15.2327 14.1643 14.7741C14.1257 14.3155 13.7218 13.9751 13.2633 14.0137C13.2633 14.0137 12.5398 14.0663 12.2223 14.0845C11.5861 14.1212 10.7306 14.1593 9.8469 14.1662C8.95824 14.1732 8.06407 14.1482 7.34249 14.064C7.27298 14.0559 7.20598 14.0473 7.14149 14.0383L15.5899 5.5899C15.9153 5.26448 15.9153 4.73682 15.5899 4.4114C15.2645 4.08598 14.7368 4.08598 14.4114 4.4114L5.9629 12.8599C5.9539 12.7953 5.94532 12.7283 5.93723 12.6587C5.85298 11.9372 5.82807 11.0431 5.83507 10.1544C5.84199 9.27065 5.88015 8.41523 5.91673 7.77898C5.93507 7.4614 5.98765 6.73723 5.98765 6.73723C6.02623 6.27865 5.68582 5.87557 5.22723 5.8369C4.76865 5.79823 4.36549 6.13923 4.32682 6.5979C4.32682 6.5979 4.27165 7.35615 4.25282 7.68323C4.21524 8.33632 4.17565 9.22107 4.1684 10.1413C4.16124 11.0565 4.18582 12.0298 4.28182 12.852C4.32965 13.262 4.3979 13.6582 4.49798 14.001C4.59082 14.3192 4.74123 14.7018 5.02032 14.9809Z"
        fill={color}
      />
    </svg>
  );
};
export const UserIcon = ({
  height = 14,
  width = 14,
  color = "#7E869A",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M4.38505 10.3217C3.44187 10.8833 0.968909 12.0301 2.47511 13.4651C3.21088 14.166 4.03033 14.6673 5.06058 14.6673H10.9394C11.9697 14.6673 12.7891 14.166 13.5249 13.4651C15.0311 12.0301 12.5581 10.8833 11.6149 10.3217C9.4032 9.00473 6.5968 9.00473 4.38505 10.3217Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 4.33398C11 5.99084 9.65687 7.33398 8 7.33398C6.34315 7.33398 5 5.99084 5 4.33398C5 2.67713 6.34315 1.33398 8 1.33398C9.65687 1.33398 11 2.67713 11 4.33398Z"
        stroke={color}
        stroke-width="1.5"
      />
    </svg>
  );
};
export const TeamIcon = ({
  height = 16,
  width = 16,
  color = "#7E869A",
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
        stroke={color}
        stroke-width="1.5"
      />
      <path
        d="M15 11C17.2091 11 19 9.20914 19 7C19 4.79086 17.2091 3 15 3"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 14H7C4.23858 14 2 16.2386 2 19C2 20.1046 2.89543 21 4 21H14C15.1046 21 16 20.1046 16 19C16 16.2386 13.7614 14 11 14Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M17 14C19.7614 14 22 16.2386 22 19C22 20.1046 21.1046 21 20 21H18.5"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ArrowRightIcon = ({
  height = 16,
  width = 16,
  color = "#3E50F7",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M11.2807 7.33312L7.70468 3.75712L8.64735 2.81445L13.8327 7.99979L8.64735 13.1851L7.70468 12.2425L11.2807 8.66645H3.16602V7.33312H11.2807Z"
        fill={color}
      />
    </svg>
  );
};
export const CalenderIcon = ({
  height = 24,
  width = 24,
  color = "#3C568D",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M11 13H16M8 13H8.00898M13 17H8M16 17H15.991"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 2V4M6 2V4"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3H12.95C16.9805 3 18.9958 3 20.2479 4.35364C21.5 5.70728 21.5 7.88594 21.5 12.2432V12.7568C21.5 17.1141 21.5 19.2927 20.2479 20.6464C18.9958 22 16.9805 22 12.95 22H11.05C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 8H21"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const UnreadMessageIcon = ({
  height = 24,
  width = 24,
  color = "#3C568D",
  className = "",
  style = {},
  ...rest
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M21.9598 10.9707C22.0134 11.8009 22.0134 12.6607 21.9598 13.4909C21.6856 17.7332 18.3536 21.1125 14.1706 21.3905C12.7435 21.4854 11.2536 21.4852 9.8294 21.3905C9.33896 21.3579 8.8044 21.2409 8.34401 21.0513C7.83177 20.8403 7.5756 20.7348 7.44544 20.7508C7.31527 20.7668 7.1264 20.9061 6.74868 21.1846C6.08268 21.6757 5.24367 22.0285 3.99943 21.9982C3.37026 21.9829 3.05568 21.9752 2.91484 21.7351C2.77401 21.495 2.94941 21.1626 3.30021 20.4978C3.78674 19.5758 4.09501 18.5203 3.62791 17.6746C2.82343 16.4666 2.1401 15.036 2.04024 13.4909C1.98659 12.6607 1.98659 11.8009 2.04024 10.9707C2.31441 6.72838 5.64639 3.34913 9.8294 3.07107C11.0318 2.99114 11.2812 2.97856 12.5 3.03368"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.5 15H15.5M8.5 10H12"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 5.5C22 7.433 20.433 9 18.5 9C16.567 9 15 7.433 15 5.5C15 3.567 16.567 2 18.5 2C20.433 2 22 3.567 22 5.5Z"
        stroke={color}
        stroke-width="1.5"
      />
    </svg>
  );
};
export const CallAddIcon = ({
  height = 24,
  width = 24,
  color = "#611FB6",
  className = "",
  style = {},
  ...rest
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M3.77762 11.9424C2.8296 10.2893 2.37185 8.93948 2.09584 7.57121C1.68762 5.54758 2.62181 3.57081 4.16938 2.30947C4.82345 1.77638 5.57323 1.95852 5.96 2.6524L6.83318 4.21891C7.52529 5.46057 7.87134 6.08139 7.8027 6.73959C7.73407 7.39779 7.26737 7.93386 6.33397 9.00601L3.77762 11.9424ZM3.77762 11.9424C5.69651 15.2883 8.70784 18.3013 12.0576 20.2224M12.0576 20.2224C13.7107 21.1704 15.0605 21.6282 16.4288 21.9042C18.4524 22.3124 20.4292 21.3782 21.6905 19.8306C22.2236 19.1766 22.0415 18.4268 21.3476 18.04L19.7811 17.1668C18.5394 16.4747 17.9186 16.1287 17.2604 16.1973C16.6022 16.2659 16.0661 16.7326 14.994 17.666L12.0576 20.2224Z"
        stroke="#611FB6"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M17 3V11M21 7H13"
        stroke="#611FB6"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const TaskIcon = ({
  height = 24,
  width = 24,
  color = "#611FB6",
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M13.1301 0.908475H10.0141L9.88746 0.339446C9.84396 0.141174 9.66778 0 9.46462 0H5.95469C5.75153 0 5.57603 0.141174 5.53184 0.339446L5.40579 0.908475H2.28918C1.14912 0.908475 0.222168 1.83577 0.222168 2.97582V17.9327C0.222168 19.0727 1.14912 20 2.28918 20H13.1302C14.2702 20 15.1979 19.0727 15.1979 17.9327V2.97582C15.1978 1.83577 14.2702 0.908475 13.1301 0.908475ZM13.8467 17.9327C13.8467 18.3275 13.5254 18.6488 13.1301 18.6488H2.28914C1.89459 18.6488 1.57328 18.3275 1.57328 17.9327V2.97582C1.57328 2.58094 1.89459 2.25967 2.28914 2.25967H5.10556L5.03368 2.58293C5.00462 2.71124 5.03631 2.84582 5.11814 2.94813C5.20055 3.05072 5.32529 3.11041 5.45652 3.11041H9.96329C10.0946 3.11041 10.2193 3.05072 10.3011 2.94813C10.3836 2.84553 10.4152 2.71128 10.3862 2.58293L10.3143 2.25967H13.1301C13.5254 2.25967 13.8467 2.58098 13.8467 2.97582V17.9327Z"
        fill={color}
      />
      <path
        d="M4.96764 8.00504H6.80503L6.36833 7.70684C5.75206 7.2863 5.59377 6.44537 6.01466 5.82919C6.43495 5.21364 7.27613 5.05432 7.89232 5.47555L7.96428 5.5247V5.00912C7.96428 4.67494 7.69311 4.40381 7.35923 4.40381H4.96764C4.63385 4.40381 4.36267 4.67498 4.36267 5.00912V7.39973C4.36267 7.73395 4.63385 8.00504 4.96764 8.00504Z"
        fill={color}
      />
      <path
        d="M10.5934 4.68653L8.47562 6.69152L7.51107 6.03344C7.20429 5.82264 6.78332 5.90247 6.57222 6.21026C6.36175 6.51831 6.44094 6.9386 6.74972 7.14907L8.16358 8.1146C8.27905 8.19379 8.41164 8.23237 8.54428 8.23237C8.71251 8.23237 8.87939 8.16974 9.00875 8.04731L11.5224 5.66761C11.7935 5.41131 11.8047 4.98345 11.5487 4.71262C11.2915 4.44179 10.8645 4.43023 10.5934 4.68653Z"
        fill={color}
      />
      <path
        d="M4.96764 12.6461H6.80571L6.36833 12.3476C5.75206 11.927 5.59377 11.0861 6.01466 10.4699C6.43495 9.854 7.27613 9.69469 7.89232 10.1163L7.96428 10.1654V9.64987C7.96428 9.31573 7.69311 9.04456 7.35923 9.04456H4.96764C4.63385 9.04456 4.36267 9.31573 4.36267 9.64987V12.0408C4.36267 12.3749 4.63385 12.6461 4.96764 12.6461Z"
        fill={color}
      />
      <path
        d="M10.5934 9.32755L8.47562 11.3322L7.51107 10.6741C7.20429 10.463 6.78332 10.5425 6.57222 10.8509C6.36175 11.1591 6.44094 11.5793 6.74972 11.7898L8.16358 12.7553C8.27905 12.8345 8.41164 12.8731 8.54428 12.8731C8.71251 12.8731 8.87939 12.8104 9.00875 12.688L11.5224 10.3086C11.7935 10.0523 11.8047 9.62481 11.5487 9.35363C11.2915 9.08276 10.8645 9.07154 10.5934 9.32755Z"
        fill={color}
      />
      <path
        d="M7.35923 13.6855H4.96764C4.63385 13.6855 4.36267 13.9567 4.36267 14.2909V16.6815C4.36267 17.0156 4.63385 17.2868 4.96764 17.2868H7.35923C7.69311 17.2868 7.96428 17.0156 7.96428 16.6815V14.2909C7.96428 13.9567 7.69311 13.6855 7.35923 13.6855Z"
        fill={color}
      />
    </svg>
  );
};

export const AppointmentIcon = ({
  height = 24,
  width = 24,
  color = "#611FB6",
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M18 2V4M6 2V4"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9955 13H12.0045M11.9955 17H12.0045M15.991 13H16M8 13H8.00897M8 17H8.00897"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.5 8H20.5"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3H12.95C16.9805 3 18.9958 3 20.2479 4.35364C21.5 5.70728 21.5 7.88594 21.5 12.2432V12.7568C21.5 17.1141 21.5 19.2927 20.2479 20.6464C18.9958 22 16.9805 22 12.95 22H11.05C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 8H21"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const EmailIcon = ({
  height = 24,
  width = 24,
  color = "#611FB6",
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M16 18H6C3 18 1 16.5 1 13V6C1 2.5 3 1 6 1H16C19 1 21 2.5 21 6V13C21 16.5 19 18 16 18Z"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.7698 5.2688L12.2228 9.5551C11.5025 10.1116 10.4973 10.1116 9.777 9.5551L4.22998 5.2688"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const DealIcon = ({
  height = 24,
  width = 24,
  color = "#611FB6",
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M4.33333 6.55556H2.11111M4.33333 15.4444H2.11111M4.33333 11H1M5.44444 2.68394C7.03344 1.6203 8.94433 1 11 1C16.5229 1 21 5.47716 21 11C21 16.5229 16.5229 21 11 21C8.94433 21 7.03344 20.3797 5.44444 19.3161M13.2222 8.22212C12.6667 8.08432 11.7612 8.07926 11 8.08432M11 8.08432C10.7454 8.08602 10.8993 8.0752 10.5556 8.08432C9.65845 8.11231 8.77956 8.48518 8.77778 9.54156C8.77583 10.6669 9.88889 10.9999 11 10.9999C12.1111 10.9999 13.2222 11.2568 13.2222 12.4582C13.2222 13.3611 12.325 13.7568 11.2068 13.8878C11.1351 13.8878 11.0663 13.8879 11 13.8882M11 8.08432V6.55556M11 13.8882C10.2442 13.8913 9.79922 13.9053 8.77778 13.7777M11 13.8882V15.4444"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const TalkTimeIcon = ({
  height = 24,
  width = 24,
  color = "#611FB6",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M12 8V12L13.5 13.5"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5454 16.4534C21.1818 17.337 22 17.7789 22 18.5C22 19.2211 21.1818 19.663 19.5454 20.5466L18.4311 21.1484C17.1744 21.827 16.5461 22.1663 16.2439 21.9196C15.504 21.3154 16.6567 19.7561 16.9403 19.2037C17.2277 18.644 17.2225 18.3459 16.9403 17.7963C16.6567 17.2439 15.504 15.6846 16.2439 15.0804C16.5461 14.8337 17.1744 15.173 18.4311 15.8516L19.5454 16.4534Z"
        stroke={color}
        stroke-width="1.5"
      />
      <path
        d="M13.0261 21.948C12.6888 21.9824 12.3464 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.6849 21.9311 13.3538 21.8 14"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const DummyChart = ({
  height = 24,
  width = 24,
  color = "#3C568D",
  className = "",
  style = {},
  ...rest
}) => {
  return (
    <svg
      width="280"
      height="280"
      viewBox="0 0 280 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_6071_2279" fill="white">
        <path d="M276 144C276 219.111 215.111 280 140 280C64.8893 280 4 219.111 4 144C4 68.8893 64.8893 8 140 8C215.111 8 276 68.8893 276 144ZM63.2367 144C63.2367 186.395 97.6048 220.763 140 220.763C182.395 220.763 216.763 186.395 216.763 144C216.763 101.605 182.395 67.2367 140 67.2367C97.6048 67.2367 63.2367 101.605 63.2367 144Z" />
      </mask>
      <path
        d="M276 144C276 219.111 215.111 280 140 280C64.8893 280 4 219.111 4 144C4 68.8893 64.8893 8 140 8C215.111 8 276 68.8893 276 144ZM63.2367 144C63.2367 186.395 97.6048 220.763 140 220.763C182.395 220.763 216.763 186.395 216.763 144C216.763 101.605 182.395 67.2367 140 67.2367C97.6048 67.2367 63.2367 101.605 63.2367 144Z"
        stroke="#FFF0EB"
        stroke-width="74"
        mask="url(#path-1-inside-1_6071_2279)"
      />
      <mask id="path-2-inside-2_6071_2279" fill="white">
        <path d="M276 144C276 119.746 269.514 95.9341 257.214 75.0306C244.915 54.1271 227.249 36.8932 206.047 25.1146C184.846 13.336 160.88 7.44141 136.634 8.04166C112.388 8.6419 88.7435 15.7151 68.1508 28.5284C47.5582 41.3416 30.7667 59.4286 19.5164 80.9151C8.26615 102.402 2.96648 126.506 4.1666 150.73C5.36671 174.953 13.023 198.416 26.3419 218.685C39.6609 238.954 58.1579 255.293 79.9162 266.008L106.087 212.866C93.8054 206.818 83.365 197.596 75.8473 186.155C68.3296 174.714 64.0081 161.471 63.3307 147.798C62.6534 134.126 65.6447 120.52 71.9947 108.393C78.3448 96.2649 87.8225 86.0559 99.4457 78.8237C111.069 71.5914 124.415 67.599 138.1 67.2602C151.786 66.9214 165.313 70.2485 177.28 76.8968C189.246 83.545 199.218 93.2725 206.16 105.071C213.102 116.87 216.763 130.31 216.763 144H276Z" />
      </mask>
      <path
        d="M276 144C276 119.746 269.514 95.9341 257.214 75.0306C244.915 54.1271 227.249 36.8932 206.047 25.1146C184.846 13.336 160.88 7.44141 136.634 8.04166C112.388 8.6419 88.7435 15.7151 68.1508 28.5284C47.5582 41.3416 30.7667 59.4286 19.5164 80.9151C8.26615 102.402 2.96648 126.506 4.1666 150.73C5.36671 174.953 13.023 198.416 26.3419 218.685C39.6609 238.954 58.1579 255.293 79.9162 266.008L106.087 212.866C93.8054 206.818 83.365 197.596 75.8473 186.155C68.3296 174.714 64.0081 161.471 63.3307 147.798C62.6534 134.126 65.6447 120.52 71.9947 108.393C78.3448 96.2649 87.8225 86.0559 99.4457 78.8237C111.069 71.5914 124.415 67.599 138.1 67.2602C151.786 66.9214 165.313 70.2485 177.28 76.8968C189.246 83.545 199.218 93.2725 206.16 105.071C213.102 116.87 216.763 130.31 216.763 144H276Z"
        stroke="#3E50F7"
        stroke-width="74"
        mask="url(#path-2-inside-2_6071_2279)"
      />
      <mask id="path-3-inside-3_6071_2279" fill="white">
        <path d="M277.728 165.117C283.104 135.638 278.88 105.212 265.677 78.3124C252.473 51.4129 230.987 29.4595 204.378 15.6801C177.769 1.90074 147.441 -2.97744 117.853 1.76284C88.2651 6.50313 60.9788 20.6117 40.0061 42.0142L87.8476 88.8949C98.786 77.7324 113.017 70.3739 128.449 67.9016C143.881 65.4293 159.699 67.9735 173.577 75.1602C187.455 82.3469 198.661 93.7969 205.547 107.826C212.434 121.856 214.637 137.725 211.833 153.1L277.728 165.117Z" />
      </mask>
      <path
        d="M277.728 165.117C283.104 135.638 278.88 105.212 265.677 78.3124C252.473 51.4129 230.987 29.4595 204.378 15.6801C177.769 1.90074 147.441 -2.97744 117.853 1.76284C88.2651 6.50313 60.9788 20.6117 40.0061 42.0142L87.8476 88.8949C98.786 77.7324 113.017 70.3739 128.449 67.9016C143.881 65.4293 159.699 67.9735 173.577 75.1602C187.455 82.3469 198.661 93.7969 205.547 107.826C212.434 121.856 214.637 137.725 211.833 153.1L277.728 165.117Z"
        stroke="#03B656"
        stroke-width="246"
        mask="url(#path-3-inside-3_6071_2279)"
      />
      <path
        d="M177.738 47.7885L179.046 46.2836L185.394 46.0853C185.945 46.056 186.422 46.0136 186.826 45.9582C187.233 45.9056 187.586 45.8145 187.885 45.6849C188.187 45.5521 188.451 45.3555 188.678 45.095C188.929 44.8056 189.08 44.4991 189.13 44.1754C189.183 43.8485 189.144 43.5295 189.013 43.2185C188.886 42.9042 188.677 42.6212 188.388 42.3695C188.086 42.1067 187.769 41.9385 187.437 41.865C187.106 41.7914 186.78 41.8157 186.459 41.9377C186.139 42.0598 185.841 42.2784 185.567 42.5935L183.585 40.8697C184.147 40.2233 184.781 39.7894 185.487 39.568C186.194 39.3465 186.924 39.3348 187.678 39.5329C188.432 39.731 189.153 40.1293 189.841 40.7276C190.548 41.3428 191.055 42.0037 191.361 42.7103C191.673 43.4165 191.784 44.1171 191.694 44.8121C191.603 45.5071 191.31 46.1391 190.816 46.7083C190.491 47.0813 190.097 47.3852 189.633 47.62C189.172 47.8575 188.563 48.036 187.804 48.1554C187.048 48.2716 186.062 48.3434 184.847 48.3708L182.175 48.53L182.117 48.5975L186.265 52.2046L184.78 53.9121L177.738 47.7885ZM186.533 55.4366L197.675 50.894L197.734 50.8265L192.963 46.6784L194.448 44.9708L201.379 50.998L199.874 52.7296L188.689 57.3114L186.533 55.4366ZM193.483 61.7002C193.165 61.4233 192.99 61.0731 192.957 60.6495C192.93 60.2254 193.056 59.8542 193.332 59.5359C193.606 59.2207 193.954 59.0485 194.375 59.0191C194.799 58.9926 195.17 59.1177 195.488 59.3945C195.797 59.6629 195.969 60.0104 196.005 60.4368C196.041 60.8632 195.922 61.234 195.648 61.5491C195.463 61.7614 195.239 61.9084 194.976 61.9902C194.719 62.0715 194.457 62.0898 194.192 62.0449C193.928 61.9968 193.692 61.8819 193.483 61.7002ZM197.627 62.0338L199.058 60.389L208.831 57.4778L210.249 58.7109L208.27 60.9876L207.43 60.2578L201.253 62.1116L201.186 62.1887L207.046 67.2848L205.591 68.9585L197.627 62.0338ZM200.859 67.8932L202.805 65.6551L203.477 64.9603L209.487 58.0482L211.446 59.7511L202.856 69.6297L200.859 67.8932ZM212.339 74.6234L212.792 74.1024C213.136 73.7069 213.536 73.4162 213.991 73.2304C214.452 73.0442 214.93 72.9912 215.425 73.0714C215.926 73.1513 216.41 73.3939 216.876 73.7993C217.349 74.2104 217.659 74.6554 217.808 75.1344C217.959 75.6162 217.971 76.0956 217.844 76.5726C217.724 77.0492 217.49 77.4869 217.143 77.8857L216.69 78.4066C216.346 78.8021 215.945 79.0944 215.487 79.2834C215.032 79.4692 214.555 79.5206 214.057 79.4376C213.556 79.3578 213.073 79.1151 212.606 78.7097C212.134 78.2986 211.825 77.852 211.679 77.3698C211.531 76.8908 211.517 76.413 211.638 75.9364C211.762 75.4566 211.995 75.0189 212.339 74.6234ZM214.196 75.323L213.743 75.8439C213.545 76.0722 213.412 76.3352 213.345 76.6329C213.281 76.9333 213.396 77.2108 213.689 77.4652C213.981 77.7197 214.267 77.7933 214.547 77.6862C214.829 77.5819 215.073 77.4124 215.277 77.1777L215.73 76.6567C215.934 76.422 216.073 76.1586 216.146 75.8665C216.219 75.5745 216.105 75.297 215.802 75.0342C215.513 74.7825 215.224 74.709 214.935 74.8138C214.647 74.9185 214.4 75.0882 214.196 75.323ZM212.186 64.562L212.639 64.0411C212.985 63.6423 213.388 63.3515 213.846 63.1684C214.308 62.9822 214.786 62.9292 215.281 63.0095C215.779 63.0925 216.258 63.3339 216.718 63.7338C217.193 64.1476 217.505 64.594 217.654 65.073C217.802 65.552 217.814 66.0314 217.691 66.5113C217.57 66.9879 217.336 67.4256 216.989 67.8243L216.536 68.3452C216.19 68.744 215.787 69.0349 215.329 69.2179C214.873 69.4037 214.397 69.4551 213.899 69.3721C213.406 69.2886 212.926 69.0427 212.456 68.6345C211.987 68.2263 211.676 67.7812 211.525 67.2995C211.379 66.8172 211.366 66.3394 211.484 65.866C211.608 65.3922 211.842 64.9575 212.186 64.562ZM214.052 65.27L213.599 65.7909C213.395 66.0257 213.261 66.2903 213.197 66.5847C213.136 66.882 213.247 67.1536 213.53 67.3997C213.826 67.6569 214.113 67.732 214.393 67.6249C214.676 67.5206 214.919 67.3511 215.123 67.1163L215.576 66.5954C215.78 66.3606 215.919 66.0972 215.992 65.8052C216.065 65.5131 215.949 65.2343 215.644 64.9686C215.358 64.7198 215.07 64.6507 214.782 64.7614C214.494 64.8722 214.25 65.0417 214.052 65.27ZM206.296 72.6211L221.677 68.648L222.941 69.7469L207.56 73.72L206.296 72.6211Z"
        fill="white"
      />
      <path
        d="M25.6214 165.597L27.509 164.507L37.6982 164.935L38.6378 166.562L36.025 168.071L35.4689 167.108L29.0243 166.85L28.9357 166.901L32.8189 173.627L30.898 174.736L25.6214 165.597ZM26.7702 172.189L29.3388 170.706L30.2002 170.268L38.1329 165.688L39.4304 167.935L28.0934 174.481L26.7702 172.189ZM32.0445 181.9C31.4985 180.945 31.2598 179.991 31.3285 179.036C31.3993 178.085 31.7692 177.17 32.4382 176.292C33.1093 175.417 34.0659 174.624 35.308 173.911C36.5443 173.198 37.7034 172.772 38.7852 172.634C39.8693 172.501 40.8353 172.644 41.6834 173.065C42.5373 173.487 43.2381 174.172 43.7857 175.121C44.3333 176.069 44.5753 177.017 44.5119 177.964C44.4506 178.914 44.091 179.826 43.4331 180.698C42.7789 181.567 41.8326 182.357 40.5942 183.067C39.3505 183.785 38.1811 184.215 37.086 184.355C35.9931 184.499 35.017 184.363 34.1579 183.949C33.2987 183.535 32.5942 182.852 32.0445 181.9ZM34.0318 180.752C34.4068 181.402 35.0328 181.732 35.9097 181.742C36.7867 181.752 37.8773 181.379 39.1816 180.621C40.0414 180.124 40.7062 179.622 41.176 179.115C41.6479 178.611 41.935 178.116 42.0375 177.628C42.1421 177.145 42.0698 176.687 41.8205 176.255C41.4477 175.61 40.8264 175.279 39.9569 175.265C39.0873 175.25 38.0075 175.613 36.7174 176.353C35.8465 176.855 35.1695 177.362 34.6866 177.872C34.2094 178.384 33.9178 178.884 33.8116 179.374C33.7091 179.861 33.7825 180.32 34.0318 180.752ZM41.5319 192.848L42.1298 192.503C42.5837 192.241 43.0561 192.096 43.5471 192.068C44.0438 192.042 44.5131 192.148 44.955 192.385C45.4027 192.623 45.781 193.01 46.0899 193.545C46.4031 194.088 46.5519 194.609 46.5361 195.111C46.5225 195.615 46.3782 196.073 46.103 196.483C45.8337 196.894 45.4702 197.232 45.0126 197.496L44.4148 197.841C43.9608 198.103 43.4866 198.249 42.992 198.279C42.5011 198.306 42.0336 198.2 41.5896 197.959C41.1419 197.721 40.7636 197.334 40.4546 196.799C40.1414 196.256 39.9945 195.733 40.014 195.23C40.0297 194.729 40.1722 194.273 40.4415 193.861C40.7146 193.448 41.078 193.11 41.5319 192.848ZM43.0598 194.114L42.462 194.459C42.2 194.61 41.9889 194.816 41.8289 195.075C41.671 195.339 41.6889 195.638 41.8828 195.974C42.0767 196.31 42.3232 196.473 42.6223 196.462C42.9236 196.456 43.2089 196.375 43.4783 196.219L44.0762 195.874C44.3456 195.718 44.5624 195.514 44.7268 195.262C44.8911 195.01 44.8731 194.71 44.6728 194.363C44.481 194.031 44.2316 193.868 43.9246 193.873C43.6175 193.878 43.3292 193.958 43.0598 194.114ZM44.6607 183.284L45.2586 182.939C45.7162 182.675 46.1915 182.531 46.6846 182.507C47.1813 182.481 47.6506 182.586 48.0925 182.823C48.5365 183.064 48.9108 183.448 49.2155 183.976C49.5309 184.522 49.6807 185.046 49.6649 185.547C49.6492 186.048 49.5048 186.505 49.2318 186.919C48.9625 187.33 48.599 187.668 48.1414 187.932L47.5436 188.277C47.0859 188.542 46.6106 188.686 46.1176 188.709C45.6267 188.737 45.1592 188.63 44.7152 188.39C44.277 188.151 43.9024 187.762 43.5913 187.223C43.2802 186.684 43.1315 186.162 43.1451 185.658C43.1645 185.154 43.307 184.698 43.5727 184.289C43.8441 183.881 44.2068 183.546 44.6607 183.284ZM46.195 184.561L45.5972 184.906C45.3278 185.062 45.1149 185.268 44.9585 185.526C44.8043 185.787 44.8209 186.08 45.0084 186.405C45.2044 186.744 45.452 186.909 45.7511 186.899C46.0524 186.892 46.3377 186.811 46.6071 186.655L47.205 186.31C47.4744 186.155 47.6912 185.951 47.8555 185.698C48.0199 185.446 48.0008 185.145 47.7984 184.794C47.6088 184.466 47.3596 184.307 47.051 184.318C46.7424 184.329 46.457 184.41 46.195 184.561ZM36.4691 188.988L52.3062 190.237L53.1435 191.687L37.3065 190.438L36.4691 188.988Z"
        fill="white"
      />
      <path
        d="M178.199 247.444C177.372 247.921 176.554 248.204 175.744 248.293C174.936 248.375 174.2 248.273 173.538 247.987C172.877 247.694 172.35 247.221 171.958 246.567L174.371 245.173C174.546 245.441 174.777 245.633 175.064 245.747C175.353 245.856 175.671 245.887 176.018 245.839C176.364 245.792 176.713 245.667 177.063 245.464C177.429 245.253 177.714 245.002 177.92 244.711C178.126 244.42 178.242 244.114 178.269 243.794C178.296 243.473 178.223 243.164 178.05 242.865C177.875 242.562 177.636 242.344 177.332 242.209C177.03 242.069 176.683 242.023 176.293 242.071C175.906 242.117 175.499 242.264 175.071 242.511L174.013 243.121L172.997 241.361L174.054 240.751C174.416 240.542 174.699 240.295 174.903 240.009C175.111 239.722 175.229 239.423 175.256 239.112C175.281 238.797 175.207 238.491 175.035 238.192C174.871 237.908 174.659 237.698 174.398 237.563C174.14 237.422 173.854 237.36 173.54 237.379C173.23 237.396 172.914 237.497 172.593 237.682C172.268 237.87 172.005 238.101 171.804 238.374C171.601 238.644 171.479 238.933 171.441 239.241C171.402 239.549 171.46 239.85 171.615 240.144L169.318 241.47C168.952 240.811 168.806 240.127 168.88 239.42C168.954 238.713 169.216 238.043 169.667 237.408C170.119 236.768 170.733 236.225 171.508 235.777C172.29 235.326 173.057 235.072 173.808 235.018C174.558 234.963 175.236 235.084 175.84 235.38C176.445 235.67 176.919 236.115 177.26 236.715C177.63 237.348 177.738 237.991 177.585 238.646C177.435 239.298 177.076 239.865 176.507 240.346L176.558 240.434C177.454 240.06 178.256 239.983 178.964 240.204C179.674 240.419 180.231 240.88 180.634 241.587C181.01 242.231 181.155 242.912 181.069 243.631C180.986 244.349 180.699 245.041 180.208 245.708C179.717 246.375 179.048 246.953 178.199 247.444ZM188.34 241.589C187.488 242.081 186.649 242.38 185.825 242.487C185.003 242.588 184.264 242.505 183.608 242.239C182.953 241.973 182.448 241.534 182.094 240.921C181.822 240.449 181.678 239.953 181.664 239.435C181.652 238.911 181.756 238.41 181.978 237.933C182.197 237.452 182.516 237.041 182.935 236.701L182.89 236.623C182.215 236.851 181.554 236.841 180.909 236.593C180.262 236.342 179.76 235.906 179.402 235.286C179.063 234.7 178.933 234.078 179.012 233.423C179.089 232.763 179.351 232.13 179.798 231.523C180.246 230.91 180.852 230.383 181.616 229.941C182.38 229.5 183.137 229.24 183.888 229.161C184.643 229.079 185.326 229.17 185.935 229.433C186.543 229.693 187.016 230.113 187.357 230.694C187.713 231.32 187.836 231.975 187.724 232.659C187.612 233.344 187.294 233.918 186.771 234.383L186.815 234.461C187.312 234.272 187.821 234.204 188.344 234.257C188.868 234.304 189.354 234.464 189.802 234.737C190.251 235.004 190.614 235.372 190.89 235.843C191.24 236.457 191.367 237.115 191.269 237.816C191.172 238.517 190.872 239.199 190.37 239.863C189.869 240.521 189.193 241.096 188.34 241.589ZM187.324 239.828C187.704 239.609 187.997 239.349 188.202 239.048C188.405 238.744 188.516 238.424 188.534 238.089C188.553 237.748 188.471 237.417 188.285 237.096C188.096 236.767 187.845 236.526 187.534 236.37C187.221 236.212 186.881 236.142 186.514 236.163C186.144 236.179 185.775 236.294 185.406 236.507C185.041 236.718 184.757 236.98 184.554 237.294C184.349 237.604 184.237 237.934 184.218 238.285C184.201 238.63 184.287 238.966 184.477 239.295C184.662 239.616 184.905 239.854 185.207 240.01C185.506 240.162 185.84 240.225 186.209 240.199C186.576 240.169 186.947 240.046 187.324 239.828ZM184.399 234.763C184.717 234.58 184.962 234.352 185.134 234.08C185.307 233.808 185.398 233.518 185.406 233.208C185.414 232.898 185.332 232.594 185.159 232.295C184.989 232 184.769 231.782 184.501 231.641C184.231 231.497 183.938 231.433 183.622 231.448C183.304 231.459 182.982 231.559 182.658 231.746C182.336 231.931 182.09 232.16 181.917 232.432C181.742 232.7 181.65 232.987 181.639 233.294C181.631 233.594 181.711 233.892 181.882 234.187C182.054 234.486 182.277 234.709 182.549 234.857C182.822 235.005 183.119 235.072 183.441 235.058C183.762 235.045 184.082 234.946 184.399 234.763ZM195.318 237.545C194.953 237.756 194.564 237.808 194.153 237.701C193.744 237.588 193.433 237.349 193.222 236.984C193.014 236.622 192.964 236.237 193.073 235.83C193.186 235.42 193.425 235.11 193.79 234.899C194.145 234.694 194.529 234.645 194.944 234.75C195.359 234.854 195.671 235.088 195.88 235.449C196.02 235.693 196.086 235.952 196.078 236.228C196.071 236.497 196.004 236.751 195.875 236.988C195.743 237.221 195.558 237.407 195.318 237.545ZM202.288 233.536C201.703 233.869 201.084 234.096 200.43 234.217C199.781 234.336 199.117 234.303 198.44 234.119C197.763 233.934 197.093 233.558 196.431 232.991C195.772 232.421 195.143 231.618 194.545 230.581C193.999 229.627 193.616 228.713 193.398 227.841C193.181 226.962 193.122 226.145 193.222 225.388C193.326 224.63 193.581 223.951 193.988 223.352C194.393 222.749 194.946 222.245 195.647 221.841C196.403 221.404 197.156 221.166 197.906 221.127C198.654 221.084 199.348 221.212 199.988 221.511C200.633 221.809 201.172 222.248 201.605 222.829L199.242 224.194C198.921 223.852 198.549 223.654 198.123 223.599C197.698 223.545 197.268 223.643 196.832 223.894C196.094 224.32 195.719 224.965 195.706 225.829C195.696 226.691 196.007 227.675 196.636 228.783L196.714 228.738C196.69 228.305 196.753 227.886 196.905 227.484C197.058 227.076 197.283 226.702 197.579 226.364C197.877 226.02 198.233 225.728 198.646 225.489C199.318 225.102 200.008 224.915 200.715 224.93C201.42 224.941 202.083 225.134 202.703 225.509C203.323 225.885 203.837 226.426 204.247 227.135C204.69 227.903 204.905 228.689 204.892 229.493C204.883 230.296 204.657 231.051 204.215 231.759C203.774 232.461 203.132 233.054 202.288 233.536ZM201.19 231.66C201.559 231.447 201.839 231.168 202.028 230.822C202.217 230.477 202.307 230.105 202.299 229.706C202.29 229.308 202.177 228.92 201.96 228.544C201.743 228.167 201.465 227.878 201.126 227.675C200.791 227.469 200.428 227.361 200.038 227.35C199.648 227.339 199.269 227.44 198.899 227.654C198.623 227.813 198.396 228.013 198.22 228.253C198.047 228.49 197.925 228.753 197.854 229.039C197.787 229.324 197.774 229.617 197.815 229.918C197.854 230.215 197.953 230.501 198.11 230.774C198.321 231.139 198.597 231.425 198.938 231.632C199.282 231.836 199.651 231.946 200.043 231.961C200.439 231.973 200.821 231.873 201.19 231.66ZM212.943 224.343L212.598 223.745C212.336 223.291 212.191 222.819 212.164 222.328C212.138 221.831 212.243 221.362 212.48 220.92C212.719 220.472 213.106 220.094 213.641 219.785C214.183 219.472 214.705 219.323 215.206 219.339C215.711 219.352 216.168 219.497 216.578 219.772C216.989 220.041 217.327 220.405 217.591 220.862L217.937 221.46C218.199 221.914 218.345 222.388 218.374 222.883C218.402 223.374 218.295 223.841 218.055 224.285C217.816 224.733 217.429 225.111 216.894 225.42C216.352 225.733 215.829 225.88 215.326 225.861C214.824 225.845 214.368 225.703 213.957 225.433C213.543 225.16 213.206 224.797 212.943 224.343ZM214.209 222.815L214.554 223.413C214.706 223.675 214.911 223.886 215.171 224.046C215.434 224.204 215.734 224.186 216.07 223.992C216.405 223.798 216.568 223.552 216.558 223.252C216.551 222.951 216.47 222.666 216.315 222.396L215.969 221.799C215.814 221.529 215.61 221.312 215.358 221.148C215.105 220.984 214.806 221.002 214.459 221.202C214.127 221.394 213.963 221.643 213.968 221.95C213.973 222.257 214.054 222.546 214.209 222.815ZM203.38 221.214L203.035 220.616C202.77 220.159 202.626 219.683 202.602 219.19C202.576 218.693 202.682 218.224 202.919 217.782C203.159 217.338 203.544 216.964 204.071 216.659C204.618 216.344 205.141 216.194 205.642 216.21C206.144 216.226 206.601 216.37 207.014 216.643C207.426 216.912 207.764 217.276 208.028 217.733L208.373 218.331C208.637 218.789 208.781 219.264 208.805 219.757C208.833 220.248 208.726 220.716 208.485 221.16C208.246 221.598 207.857 221.972 207.319 222.284C206.78 222.595 206.258 222.743 205.753 222.73C205.25 222.71 204.794 222.568 204.384 222.302C203.977 222.031 203.642 221.668 203.38 221.214ZM204.656 219.68L205.002 220.278C205.157 220.547 205.364 220.76 205.621 220.916C205.883 221.071 206.176 221.054 206.5 220.866C206.84 220.67 207.005 220.423 206.994 220.124C206.988 219.822 206.906 219.537 206.751 219.268L206.406 218.67C206.25 218.4 206.046 218.184 205.794 218.019C205.542 217.855 205.24 217.874 204.89 218.076C204.561 218.266 204.402 218.515 204.413 218.824C204.424 219.132 204.505 219.418 204.656 219.68ZM209.083 229.406L210.332 213.569L211.783 212.731L210.534 228.568L209.083 229.406Z"
        fill="#3C568D"
      />
      <g filter="url(#filter0_di_6071_2279)">
        <circle cx="140" cy="141" r="55" fill="white" />
      </g>
      <path
        d="M118.756 122.909V136H115.989V125.536H115.912L112.914 127.415V124.961L116.155 122.909H118.756ZM122.582 136.166C122.16 136.166 121.798 136.017 121.495 135.719C121.197 135.416 121.048 135.054 121.048 134.632C121.048 134.214 121.197 133.857 121.495 133.558C121.798 133.26 122.16 133.111 122.582 133.111C122.991 133.111 123.349 133.26 123.656 133.558C123.962 133.857 124.116 134.214 124.116 134.632C124.116 134.913 124.043 135.171 123.899 135.406C123.758 135.636 123.573 135.821 123.342 135.962C123.112 136.098 122.859 136.166 122.582 136.166ZM130.186 122.909V136H127.419V125.536H127.342L124.344 127.415V124.961L127.585 122.909H130.186ZM137.937 136.179C136.982 136.179 136.132 136.015 135.386 135.687C134.645 135.354 134.059 134.898 133.628 134.319C133.202 133.735 132.983 133.062 132.97 132.299H135.757C135.774 132.619 135.878 132.9 136.07 133.143C136.266 133.381 136.526 133.567 136.85 133.699C137.174 133.831 137.538 133.897 137.943 133.897C138.365 133.897 138.738 133.822 139.062 133.673C139.385 133.524 139.639 133.317 139.822 133.053C140.005 132.789 140.097 132.484 140.097 132.139C140.097 131.79 139.999 131.481 139.803 131.212C139.611 130.94 139.334 130.727 138.972 130.573C138.614 130.42 138.188 130.343 137.694 130.343H136.473V128.31H137.694C138.111 128.31 138.48 128.238 138.8 128.093C139.123 127.948 139.375 127.748 139.554 127.492C139.733 127.232 139.822 126.93 139.822 126.585C139.822 126.256 139.743 125.969 139.586 125.722C139.432 125.47 139.215 125.274 138.934 125.134C138.657 124.993 138.333 124.923 137.962 124.923C137.587 124.923 137.244 124.991 136.933 125.127C136.622 125.259 136.373 125.449 136.185 125.696C135.998 125.943 135.898 126.233 135.885 126.565H133.232C133.245 125.811 133.46 125.146 133.878 124.571C134.295 123.996 134.858 123.546 135.565 123.222C136.277 122.894 137.08 122.73 137.975 122.73C138.878 122.73 139.669 122.894 140.346 123.222C141.024 123.55 141.55 123.994 141.925 124.552C142.304 125.106 142.492 125.728 142.488 126.418C142.492 127.151 142.264 127.763 141.804 128.253C141.348 128.743 140.753 129.054 140.02 129.186V129.288C140.983 129.412 141.716 129.746 142.219 130.292C142.726 130.833 142.978 131.511 142.974 132.325C142.978 133.07 142.763 133.733 142.328 134.312C141.898 134.892 141.303 135.348 140.545 135.68C139.786 136.013 138.917 136.179 137.937 136.179ZM149.544 136.179C148.641 136.179 147.835 136.013 147.128 135.68C146.425 135.348 145.867 134.89 145.453 134.306C145.04 133.722 144.825 133.053 144.808 132.299H147.492C147.522 132.806 147.735 133.217 148.132 133.533C148.528 133.848 148.999 134.006 149.544 134.006C149.979 134.006 150.362 133.91 150.695 133.718C151.031 133.522 151.294 133.251 151.481 132.906C151.673 132.557 151.769 132.156 151.769 131.705C151.769 131.244 151.671 130.839 151.475 130.49C151.283 130.141 151.017 129.868 150.676 129.672C150.335 129.476 149.945 129.376 149.506 129.371C149.122 129.371 148.75 129.45 148.387 129.608C148.029 129.766 147.75 129.981 147.55 130.254L145.089 129.812L145.709 122.909H153.712V125.172H147.991L147.652 128.451H147.729C147.959 128.127 148.306 127.859 148.771 127.646C149.235 127.433 149.755 127.326 150.331 127.326C151.119 127.326 151.822 127.511 152.44 127.882C153.058 128.253 153.546 128.762 153.904 129.41C154.262 130.053 154.438 130.795 154.434 131.634C154.438 132.516 154.234 133.3 153.821 133.987C153.411 134.668 152.838 135.205 152.101 135.597C151.368 135.985 150.516 136.179 149.544 136.179Z"
        fill="#141928"
      />
      <path
        d="M114.466 150.818V161H113.233V150.818H114.466ZM117.852 156.406V161H116.679V153.364H117.812V154.557H117.912C118.091 154.169 118.363 153.857 118.727 153.622C119.092 153.384 119.562 153.264 120.139 153.264C120.656 153.264 121.109 153.37 121.496 153.582C121.884 153.791 122.186 154.109 122.401 154.537C122.617 154.961 122.724 155.498 122.724 156.148V161H121.551V156.227C121.551 155.627 121.395 155.16 121.084 154.825C120.772 154.487 120.345 154.318 119.801 154.318C119.427 154.318 119.092 154.399 118.797 154.562C118.505 154.724 118.275 154.961 118.106 155.273C117.937 155.584 117.852 155.962 117.852 156.406ZM130.739 153.364L127.915 161H126.722L123.898 153.364H125.171L127.279 159.449H127.359L129.467 153.364H130.739ZM135.017 161.159C134.327 161.159 133.722 160.995 133.202 160.667C132.685 160.339 132.281 159.88 131.989 159.29C131.701 158.7 131.557 158.01 131.557 157.222C131.557 156.426 131.701 155.732 131.989 155.138C132.281 154.545 132.685 154.085 133.202 153.756C133.722 153.428 134.327 153.264 135.017 153.264C135.706 153.264 136.309 153.428 136.826 153.756C137.347 154.085 137.751 154.545 138.039 155.138C138.331 155.732 138.477 156.426 138.477 157.222C138.477 158.01 138.331 158.7 138.039 159.29C137.751 159.88 137.347 160.339 136.826 160.667C136.309 160.995 135.706 161.159 135.017 161.159ZM135.017 160.105C135.54 160.105 135.971 159.971 136.309 159.702C136.647 159.434 136.898 159.081 137.06 158.643C137.222 158.206 137.304 157.732 137.304 157.222C137.304 156.711 137.222 156.236 137.06 155.795C136.898 155.354 136.647 154.998 136.309 154.726C135.971 154.454 135.54 154.318 135.017 154.318C134.493 154.318 134.062 154.454 133.724 154.726C133.386 154.998 133.136 155.354 132.973 155.795C132.811 156.236 132.73 156.711 132.73 157.222C132.73 157.732 132.811 158.206 132.973 158.643C133.136 159.081 133.386 159.434 133.724 159.702C134.062 159.971 134.493 160.105 135.017 160.105ZM140.168 161V153.364H141.341V161H140.168ZM140.765 152.091C140.536 152.091 140.339 152.013 140.173 151.857C140.011 151.701 139.929 151.514 139.929 151.295C139.929 151.077 140.011 150.889 140.173 150.734C140.339 150.578 140.536 150.5 140.765 150.5C140.993 150.5 141.189 150.578 141.351 150.734C141.517 150.889 141.6 151.077 141.6 151.295C141.6 151.514 141.517 151.701 141.351 151.857C141.189 152.013 140.993 152.091 140.765 152.091ZM146.493 161.159C145.777 161.159 145.16 160.99 144.643 160.652C144.126 160.314 143.728 159.848 143.45 159.255C143.172 158.662 143.032 157.984 143.032 157.222C143.032 156.446 143.175 155.762 143.46 155.168C143.748 154.572 144.149 154.106 144.663 153.771C145.18 153.433 145.783 153.264 146.473 153.264C147.01 153.264 147.493 153.364 147.924 153.562C148.355 153.761 148.708 154.04 148.983 154.398C149.258 154.756 149.429 155.173 149.495 155.651H148.322C148.233 155.303 148.034 154.994 147.725 154.726C147.421 154.454 147.01 154.318 146.493 154.318C146.035 154.318 145.634 154.437 145.289 154.676C144.948 154.911 144.681 155.245 144.489 155.675C144.3 156.103 144.206 156.605 144.206 157.182C144.206 157.772 144.298 158.286 144.484 158.723C144.673 159.161 144.938 159.5 145.279 159.742C145.624 159.984 146.029 160.105 146.493 160.105C146.797 160.105 147.074 160.052 147.323 159.946C147.571 159.84 147.782 159.688 147.954 159.489C148.127 159.29 148.249 159.051 148.322 158.773H149.495C149.429 159.223 149.265 159.629 149.003 159.991C148.745 160.349 148.402 160.634 147.974 160.846C147.55 161.055 147.056 161.159 146.493 161.159ZM154.312 161.159C153.576 161.159 152.942 160.997 152.408 160.672C151.878 160.344 151.469 159.886 151.18 159.3C150.895 158.71 150.753 158.024 150.753 157.241C150.753 156.459 150.895 155.77 151.18 155.173C151.469 154.573 151.87 154.106 152.383 153.771C152.9 153.433 153.504 153.264 154.193 153.264C154.591 153.264 154.983 153.33 155.371 153.463C155.759 153.596 156.112 153.811 156.43 154.109C156.748 154.404 157.002 154.795 157.191 155.283C157.38 155.77 157.474 156.37 157.474 157.082V157.58H151.588V156.565H156.281C156.281 156.134 156.195 155.75 156.023 155.412C155.853 155.074 155.612 154.807 155.297 154.612C154.985 154.416 154.617 154.318 154.193 154.318C153.726 154.318 153.321 154.434 152.98 154.666C152.642 154.895 152.382 155.193 152.199 155.561C152.017 155.929 151.926 156.323 151.926 156.744V157.42C151.926 157.997 152.025 158.486 152.224 158.887C152.426 159.285 152.706 159.588 153.064 159.797C153.422 160.002 153.838 160.105 154.312 160.105C154.621 160.105 154.899 160.062 155.148 159.976C155.399 159.886 155.617 159.754 155.799 159.578C155.981 159.399 156.122 159.177 156.221 158.912L157.355 159.23C157.236 159.615 157.035 159.953 156.753 160.244C156.472 160.533 156.124 160.758 155.709 160.92C155.295 161.08 154.829 161.159 154.312 161.159ZM164.568 155.074L163.514 155.372C163.448 155.196 163.35 155.026 163.221 154.86C163.095 154.691 162.923 154.552 162.704 154.442C162.485 154.333 162.205 154.278 161.864 154.278C161.396 154.278 161.007 154.386 160.695 154.602C160.387 154.814 160.233 155.084 160.233 155.412C160.233 155.704 160.339 155.934 160.551 156.103C160.763 156.272 161.095 156.413 161.545 156.526L162.679 156.804C163.362 156.97 163.87 157.223 164.205 157.565C164.54 157.903 164.707 158.339 164.707 158.872C164.707 159.31 164.581 159.701 164.329 160.045C164.081 160.39 163.733 160.662 163.285 160.861C162.838 161.06 162.318 161.159 161.724 161.159C160.945 161.159 160.301 160.99 159.79 160.652C159.28 160.314 158.957 159.82 158.821 159.17L159.935 158.892C160.041 159.303 160.241 159.611 160.536 159.817C160.834 160.022 161.224 160.125 161.704 160.125C162.251 160.125 162.686 160.009 163.007 159.777C163.332 159.542 163.494 159.26 163.494 158.932C163.494 158.667 163.401 158.445 163.216 158.266C163.03 158.083 162.745 157.947 162.361 157.858L161.088 157.56C160.389 157.394 159.875 157.137 159.547 156.789C159.222 156.438 159.06 155.999 159.06 155.472C159.06 155.041 159.181 154.66 159.423 154.328C159.668 153.997 160.001 153.737 160.422 153.548C160.846 153.359 161.327 153.264 161.864 153.264C162.619 153.264 163.213 153.43 163.643 153.761C164.078 154.093 164.386 154.53 164.568 155.074Z"
        fill="#141928"
      />
      <defs>
        <filter
          id="filter0_di_6071_2279"
          x="83"
          y="85"
          width="114"
          height="114"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6071_2279"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6071_2279"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6071_2279"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const searchIcon = (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="#9ea0a8"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0252 14.3469L18.5943 17.9152L17.4152 19.0943L13.8469 15.5252C12.5191 16.5895 10.8677 17.1684 9.16602 17.166C5.02602 17.166 1.66602 13.806 1.66602 9.66602C1.66602 5.52602 5.02602 2.16602 9.16602 2.16602C13.306 2.16602 16.666 5.52602 16.666 9.66602C16.6684 11.3677 16.0895 13.0191 15.0252 14.3469ZM13.3535 13.7285C14.4111 12.6409 15.0017 11.183 14.9993 9.66602C14.9993 6.44268 12.3885 3.83268 9.16602 3.83268C5.94268 3.83268 3.33268 6.44268 3.33268 9.66602C3.33268 12.8885 5.94268 15.4993 9.16602 15.4993C10.683 15.5017 12.1409 14.9111 13.2285 13.8535L13.3535 13.7285Z"
      fill={0.4}
      fillOpacity="#0D1126"
    />
  </svg>
);

export const activityIcon = (
  <svg
    fill="none"
    height="20"
    viewBox="0 0 24 24"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-rule="evenodd" fill="#fff" fill-rule="evenodd">
      <path d="m3.09467 3.09467c1.33447-1.33447 3.33136-1.84467 5.90533-1.84467h6c2.574 0 4.5709.5102 5.9053 1.84467 1.3345 1.33447 1.8447 3.33136 1.8447 5.90533v6c0 2.574-.5102 4.5709-1.8447 5.9053-1.3344 1.3345-3.3313 1.8447-5.9053 1.8447h-6c-2.57397 0-4.57086-.5102-5.90533-1.8447-1.33447-1.3344-1.84467-3.3313-1.84467-5.9053v-6c0-2.57397.5102-4.57086 1.84467-5.90533zm1.06066 1.06066c-.91553.91553-1.40533 2.41864-1.40533 4.84467v6c0 2.426.4898 3.9291 1.40533 4.8447.91553.9155 2.41864 1.4053 4.84467 1.4053h6c2.426 0 3.9291-.4898 4.8447-1.4053.9155-.9156 1.4053-2.4187 1.4053-4.8447v-6c0-2.42603-.4898-3.92914-1.4053-4.84467-.9156-.91553-2.4187-1.40533-4.8447-1.40533h-6c-2.42603 0-3.92914.4898-4.84467 1.40533z" />
      <path d="m17.1296 8.91704c.3274.25377.387.72488.1333 1.05225l-2.3144 2.98571c-.5949.7523-1.6918.8895-2.457.2983l-.0052-.0041-1.8266-1.4373c-.1128-.0857-.2702-.0644-.3559.0462 0 .0001.0001-.0002 0 0l-2.3795 3.0894c-.25276.3281-.72368.3892-1.05184.1365-.32816-.2528-.38928-.7237-.13653-1.0519l2.38072-3.0909c.59391-.7686 1.69515-.9075 2.46205-.3149l.0052.0041 1.8266 1.4373c.114.0866.2747.0643.3598-.0412l2.3071-2.97619c.2537-.32737.7248-.38704 1.0522-.13327z" />
    </g>
  </svg>
);
export const inboxIcon = (
    <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1706 20.3905C18.3536 20.1125 21.6856 16.7332 21.9598 12.4909C22.0134 11.6607 22.0134 10.8009 21.9598 9.9707C21.6856 5.72838 18.3536 2.34913 14.1706 2.07107C12.7435 1.97621 11.2536 1.97641 9.8294 2.07107C5.64639 2.34913 2.31441 5.72838 2.04024 9.9707C1.98659 10.8009 1.98659 11.6607 2.04024 12.4909C2.1401 14.036 2.82343 15.4666 3.62791 16.6746C4.09501 17.5203 3.78674 18.5758 3.30021 19.4978C2.94941 20.1626 2.77401 20.495 2.91484 20.7351C3.05568 20.9752 3.37026 20.9829 3.99943 20.9982C5.24367 21.0285 6.08268 20.6757 6.74868 20.1846C7.1264 19.9061 7.31527 19.7668 7.44544 19.7508C7.5756 19.7348 7.83177 19.8403 8.34401 20.0513C8.8044 20.2409 9.33896 20.3579 9.8294 20.3905C11.2536 20.4852 12.7435 20.4854 14.1706 20.3905Z"
      stroke="#fff"
      stroke-width="1.5"
      stroke-linejoin="round"
    ></path>
    <path
      d="M8.5 14H15.5M8.5 9H12"
      stroke="#fff"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
);
export const notificationIcon = (
    <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.99935 14.8724C14.6987 14.8724 16.8727 14.2695 17.0827 11.8498C17.0827 9.43168 15.567 9.58717 15.567 6.62027C15.567 4.3028 13.3704 1.66602 9.99935 1.66602C6.62833 1.66602 4.43172 4.3028 4.43172 6.62027C4.43172 9.58717 2.91602 9.43168 2.91602 11.8498C3.12681 14.2787 5.30083 14.8724 9.99935 14.8724Z"
      stroke="#fff"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      opacity="0.4"
      d="M11.9894 17.3809C10.8526 18.6431 9.07929 18.6581 7.93164 17.3809"
      stroke="#fff"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
);
export const ActivityIcon = ({width="24", height="24", fill="#fff"}) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-rule="evenodd" fill="rgb(0,0,0)" fill-rule="evenodd">
        <path d="m3.09467 3.09467c1.33447-1.33447 3.33136-1.84467 5.90533-1.84467h6c2.574 0 4.5709.5102 5.9053 1.84467 1.3345 1.33447 1.8447 3.33136 1.8447 5.90533v6c0 2.574-.5102 4.5709-1.8447 5.9053-1.3344 1.3345-3.3313 1.8447-5.9053 1.8447h-6c-2.57397 0-4.57086-.5102-5.90533-1.8447-1.33447-1.3344-1.84467-3.3313-1.84467-5.9053v-6c0-2.57397.5102-4.57086 1.84467-5.90533zm1.06066 1.06066c-.91553.91553-1.40533 2.41864-1.40533 4.84467v6c0 2.426.4898 3.9291 1.40533 4.8447.91553.9155 2.41864 1.4053 4.84467 1.4053h6c2.426 0 3.9291-.4898 4.8447-1.4053.9155-.9156 1.4053-2.4187 1.4053-4.8447v-6c0-2.42603-.4898-3.92914-1.4053-4.84467-.9156-.91553-2.4187-1.40533-4.8447-1.40533h-6c-2.42603 0-3.92914.4898-4.84467 1.40533z" />
        <path d="m17.1296 8.91704c.3274.25377.387.72488.1333 1.05225l-2.3144 2.98571c-.5949.7523-1.6918.8895-2.457.2983l-.0052-.0041-1.8266-1.4373c-.1128-.0857-.2702-.0644-.3559.0462 0 .0001.0001-.0002 0 0l-2.3795 3.0894c-.25276.3281-.72368.3892-1.05184.1365-.32816-.2528-.38928-.7237-.13653-1.0519l2.38072-3.0909c.59391-.7686 1.69515-.9075 2.46205-.3149l.0052.0041 1.8266 1.4373c.114.0866.2747.0643.3598-.0412l2.3071-2.97619c.2537-.32737.7248-.38704 1.0522-.13327z" />
      </g>
    </svg>
  );
}